import React, { useEffect } from 'react';
import { Box, Button, Card, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import confetti from 'canvas-confetti';

const SectionCard = styled(Card)(({ theme }) => ({
  width: '100%',
  maxWidth: 800,
  borderRadius: 16,
  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
}));

export default function Step5Completion({ onFinish }) {
  useEffect(() => {
    // Trigger confetti effect when component mounts
    const duration = 2 * 1000;
    const end = Date.now() + duration;

    (function frame() {
      confetti({
        particleCount: 4,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
      });
      confetti({
        particleCount: 4,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
      });
      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }, []);

  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: 'flex', justifyContent: 'center' }}>
      <SectionCard sx={{ p: 4, textAlign: 'center', background: 'linear-gradient(135deg, #E3F2FD 0%, #E8F5E9 100%)' }}>
        <EmojiEventsIcon sx={{ fontSize: 60, color: 'primary.main' }} />
        <Typography variant="h4" sx={{ fontWeight: 900, mt: 1 }}>
          Congratulations! 🎉
        </Typography>
        <Typography sx={{ mt: 1, color: 'text.secondary' }}>
          Your onboarding is complete. You’re now ready to launch your first pentest and explore your dashboard.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
          <Button variant="contained" onClick={onFinish} sx={{ px: 4, py: 1.25, borderRadius: 12, fontWeight: 700 }}>
            Finish
          </Button>
        </Box>
      </SectionCard>
    </Box>
  );
}
